// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".Error[data-v-2d9dfdee]{align-items:center;display:flex;flex-direction:column;height:500px;justify-content:center;padding:16px;width:100%}.message[data-v-2d9dfdee]{margin-bottom:24px}.link[data-v-2d9dfdee]{color:#ef6530;font-weight:700;transition:.3s}.link[data-v-2d9dfdee]:hover{-webkit-text-decoration:underline;text-decoration:underline}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
